import { Component, Input, Output, EventEmitter } from '@angular/core'
import { Router } from '@angular/router'
import { State, Types, Observable, Store, User, AppFields, Todo } from '../../store'

@Component({
  selector: 'app-top-bar-com',
  templateUrl: 'top-bar.com.html',
  styleUrls: ['top-bar.com.scss']
})

export class TopBarComponent {

  @Output() event = new EventEmitter<any>()
  user: Observable<User>

  constructor(private store: Store<State>, private router: Router) {
    this.user = this.store.select(AppFields.App, AppFields.User)
  }

  public showSideMenu() {
    this.event.emit({ source: 'top-bar-collapse', action: 'click' })
  }

  private logOut(): void {
    this.router.navigate(['/'])
    this.store.dispatch({ type: Types.LogOut })
  }

}



// WEBPACK FOOTER //
// ./src/app/com/top-bar/top-bar.com.ts